import React from "react";
import { Helmet } from "react-helmet";
import "./About.css";
// import './assets';
import profile from "./assets/profile.png"; 

const About = () => {
  return (
    <section className="about" id="about">
      <Helmet>
        <title>About Us | NextEdge</title>
        <meta
          name="description"
          content="NextEdge is a digital solutions company specializing in static websites, dynamic websites, mobile apps, and creative posters."
        />
        <meta
          name="keywords"
          content="NextEdge, about NextEdge, web development company, app development, UI UX design"
        />
      </Helmet>

      <div className="about-container">
        <h2 className="section-title">About Us</h2>
        <p className="section-subtitle">
          Who we are and what makes us different.
        </p>

        <div className="about-content">
          <div className="about-text">
            <p>
              At <strong>NextEdge</strong>, we combine creativity, technology,
              and innovation to deliver powerful digital solutions. Whether you
              need a professional static website, a feature-rich dynamic
              platform, mobile applications, or eye-catching posters, we bring
              your vision to life.
            </p>
            <p>
              Our mission is to empower businesses and individuals with modern
              tools that are fast, scalable, and user-friendly. With a focus on
              design and functionality, we ensure every project leaves a lasting
              impact.
            </p>
            <p>
              Based in Rajasthan, we’ve proudly helped clients from different
              industries achieve success in the digital world.
            </p>
          </div>

          <div className="about-image">
            <img src={profile} alt="NextEdge Team" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
